import axios from '@/shared/axios';

/**
 * track report
 */
export function reportTrackData(params: Record<string, any>) {
  // return axios.post('/operate/check', params, {
  return axios.post('/traceMonitor/occurence', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}
